import React, { Component } from 'react';
import MainMediaContent from '../../../Media/MainMediaContent';
import Button from '../../../Buttons/Button';
import './TabGallery.scss';

class TabGallery extends Component {
  state = {
    activeIndex: 0,
  };

  componentDidUpdate(prevProps, prevState) {
    const { getMediaIndex } = this.props;
    const { activeIndex } = this.state;
    if (prevState.activeIndex !== activeIndex) {
      getMediaIndex(activeIndex);
    }
  }
  /**
   * A function to validate the media name.
   * If the name contains gif,jpe,jpeg,tiff,png an empty string will be returned.
   * @param {string} name The name to validate
   * @returns {string} A validated string
   */
  validateMediaName = name => {
    let value = name;
    if (value && value.match(/\.(gif|jpe?g|tiff|png)$/i)) {
      value = '';
    }
    return value;
  };

  showMainMedia = () => {
    const {
      autoPlay,
      media,
      mediaLibrary,
      primaryColor,
      tourId,
      tourName,
    } = this.props;

    const { activeIndex } = this.state;

    return media.map((media, index) => {
      return (
        activeIndex === index && (
          <div className="main-media-content__wrapper" key={media.id}>
            <MainMediaContent
              autoPlay={autoPlay}
              height={550}
              width={800}
              id={media.id}
              alt={media.alt || ''}
              mediaType={media.type}
              className="main-media"
              videoSrc={media.src}
              tourId={tourId}
              tourName={tourName}
              primaryColor={primaryColor}
              media={media}
              mediaLibrary={mediaLibrary}
              transcript={media.transcript}
            />
            {this.validateMediaName(media.name) && (
              <h4 className="media-title">{media.name}</h4>
            )}
          </div>
        )
      );
    });
  };

  changeMedia = index => {
    const { media } = this.props;
    if (index < 0) {
      index = media.length - 1;
    }
    if (index === media.length) {
      index = 0;
    }
    this.setState({ activeIndex: index });
  };

  render() {
    const { activeIndex } = this.state;
    const { media } = this.props;
    return (
      <React.Fragment>
        {this.showMainMedia()}
        {media.length > 1 && [
          <Button
            key="prev-btn"
            name="Previous"
            className="carousel-btn left"
            handleClick={() => this.changeMedia(activeIndex - 1)}
            data-cy="carousel-prev-btn"
            aria-label={`previous ${media[activeIndex].type.slice(0, -1)}`} // removes trailing "s" from videos & images media.type
          >
            <i className="material-icons">arrow_back</i>
          </Button>,
          <Button
            key="next-btn"
            name="Next"
            className="carousel-btn right"
            handleClick={() => this.changeMedia(activeIndex + 1)}
            data-cy="carousel-next-btn"
            aria-label={`next ${media[activeIndex].type.slice(0, -1)}`} // removes trailing "s" from videos & images media.type
          >
            <i className="material-icons">arrow_forward</i>
          </Button>,
        ]}
      </React.Fragment>
    );
  }
}

export default TabGallery;
